module.exports = __webpack_public_path__ + "img/question-mark.3d7fa23a.png";